/* eslint-disable default-case */
/* eslint-disable consistent-return */

/* FETCHER ORM MODELS */
import Feed from '@/vuex/orm/fetcher/admin/models/Feed';
import FeedRule from '@/vuex/orm/fetcher/admin/models/FeedRule';
import Job from '@/vuex/orm/fetcher/admin/models/Job';
import List from '@/vuex/orm/fetcher/admin/models/List';
import Network from '@/vuex/orm/fetcher/admin/models/Network';
import Profile from '@/vuex/orm/fetcher/admin/models/Profile';
import Tag from '@/vuex/orm/fetcher/admin/models/Tag';
import WikipediaPage from '@/vuex/orm/fetcher/admin/models/WikipediaPage';

/* SPAWNER ORM MODELS */
import Repository from '@/vuex/orm/spawner/admin/models/Repository';
import DomainTld from '@/vuex/orm/spawner/admin/models/DomainTld';
import Template from '@/vuex/orm/spawner/admin/models/Template';
import Domain from '@/vuex/orm/spawner/admin/models/Domain';
import Deployment from '@/vuex/orm/spawner/admin/models/Deployment';
import Site from '@/vuex/orm/spawner/admin/models/Site';
import Server from '@/vuex/orm/spawner/admin/models/Server';

export default {

  methods: {

    getOrmEntity(selectModel) {
      switch (selectModel) {
        /* FETCHER ORM SWITCHCASE */
        case 'Feed':
          return Feed;
        case 'FeedRule':
          return FeedRule;
        case 'Job':
          return Job;
        case 'List':
          return List;
        case 'Network':
          return Network;
        case 'Profile':
          return Profile;
        case 'Tag':
          return Tag;
        case 'WikipediaPage':
          return WikipediaPage;

        /* SPAWNER ORM SWITCHCASE */
        case 'Repository':
          return Repository;
        case 'DomainTld':
          return DomainTld;
        case 'Template':
          return Template;
        case 'Domain':
          return Domain;
        case 'Deployment':
          return Deployment;
        case 'Site':
          return Site;
        case 'Server':
          return Server;
      }
    },
  },
};
